export default __webpack_public_path__ + "static/media/26.47d15828.jpg";